import PurchaseBusinessService from '../../purchase-business-service';
import SummaryInfo from './summary-info/summary-info.vue';
import ProjectInfo from './project-info/project-info.vue';
import AttachmentInfo from './attachment-info/attachment-info.vue';
import OtherInfo from './other-info/other-info.vue';
import DealInfo from './deal-info/deal-info.vue';
import Service from '@/service/index.js';
export default {
  components: {
    SummaryInfo,
    ProjectInfo,
    AttachmentInfo,
    OtherInfo,
    DealInfo
  },
  data() {
    return {
      id: '',
      projectInfo: null, // 项目信息
      attachmentInfo: [], // 附件信息
      otherInfo: [], // 其他信息
      arr: ['项目信息', '附件信息', '其他信息', '项目文件信息'],
      activeKey: '项目信息',
      fileObj: {
        docUrl: '',
        docUrl1: '',
        docUrl4: '',
        docUrl5: '', // 鉴证书
        docUrl6: '', // 见证书
        docUrl7: '' // 11 12 采购项目合同
      },
      docUrl2: [],
      docUrl3: [],
      fileInfo: [],  // 项目文件
      purchaseContractTypeList: []
    };
  },
  created() {
    this.id = this.$route.query.id;
    // 获取合同类型
    Service.getSelectList('PURCHASE_CONTRACT_TYPE').then(res => {
      if (res && res.code === '0') {
        this.purchaseContractTypeList = res.data;
      }
    });
    this.getProjectDetail();
    this.initImageInfo();
  },
  computed: {
  },
  methods: {
    getProjectDetail () {
      const obj = {
        PURCHASE: 'projectInfo'
      };
      Object.keys(obj).forEach(key => {
        PurchaseBusinessService.getPurchaseProjectDetail({
          purchaseId: this.id,
          echoCode: key
        }).then(res => {
          this[obj[key]] = res && res.data;
          // if (this.projectInfo.purchaseType === 1) {
          //   this.getPurchaseFileList(7);
          // } else if (this.projectInfo.purchaseType === 3) {
          //   this.getPurchaseFileList(6);
          // }
          // let num;
          // if (this.projectInfo.projectType === 1) {
          //   num = 1;
          // } else if (this.projectInfo.projectType === 2 && this.projectInfo.purchaseType === 1) {
          //   num = 3;
          // } else if (this.projectInfo.projectType === 2 && this.projectInfo.purchaseType === 3) {
          //   num = 2;
          // } else if (this.projectInfo.projectType === 3 && this.projectInfo.purchaseType === 3) {
          //   num = 4;
          // } else if (this.projectInfo.projectType === 3 && this.projectInfo.purchaseType === 1) {
          //   num = 5;
          // }
          // 获取采购人项目文件信息
          this.getPurchaseFileList();
        });
      });
    },
    changeActiveIndex (key) {
      this.activeKey = key;
    },
    initImageInfo () {
      Promise.all([this.getPurchaseFileType(), this.getAttachmentInfo()]).then(res => {
        const arr = JSON.parse(JSON.stringify(res[0])).sort((a, b) => a.sort - b.sort);
        // 初始化附件信息
        // const arr1 = arr.slice(0, 6);
        const arr1 = arr;
        arr1.forEach(item => {
          let obj = res[1].find(file => file.projectFileType === Number(item.code));
          this.attachmentInfo.push({
            projectFileType: Number(item.code),
            title: item.value,
            fileName: obj?.fileName,
            filePaths: obj && (obj.filePaths.map(item => item.allPath)) || []
          });
        });
        // 初始化其他信息
        // const arr2 = arr.slice(arr.length - 3);

        // 2021-03-01 fyh 只展示公告和公示照片
        const arr2 = arr.slice(7, 9);
        arr2.forEach(item => {
          let obj = res[1].find(file => file.projectFileType === Number(item.code));
          this.otherInfo.push({
            projectFileType: Number(item.code),
            title: item.value,
            filePaths: obj && (obj.filePaths.map(item => item.allPath)) || []
          });
        });
      });
    },
    // 获取采购人项目文件信息
    getPurchaseFileList () {
      PurchaseBusinessService.getFileList(this.id).then(res => {
        if (res && res.code === '0') {
          this.fileInfo = res.data;
          res.data && res.data.map(item => {
            if(!item.contractName) {
              let resultData = this.purchaseContractTypeList.find(purItem => purItem.code === item.type);
              if(resultData){
                item.contractName = `${resultData.value}(${item.userName})`;
              }
            }
          });
          // res.data && res.data.forEach(item => {
          //   if(item.type === '1' || item.type === '2' || item.type === '3' || item.type === '4' || item.type === '5' ) {
          //     this.fileObj.docUrl = item.url;
          //   } else if (item.type === '6' || item.type === '7') {
          //     this.fileObj.docUrl1 = item.url;
          //   } else if (item.type === '8') {
          //     this.docUrl2.push(item);
          //   } else if (item.type === '9') {
          //     this.docUrl3.push(item);
          //   } else if(item.type === '11' || item.type === '12') {
          //     this.fileObj.docUrl7 = item.url;
          //   } else if(item.type === '13') {
          //     this.fileObj.docUrl5 = item.url;
          //   } else if(item.type === '14') {
          //     this.fileObj.docUrl6 = item.url;
          //   } else {
          //     this.fileObj.docUrl4 = item.url;
          //   }
          // });
        }
      });
    },
    getPurchaseFileType () {
      return new Promise((resolve, reject) => {
        Service.getSelectList('PURCHASE_FILE').then(res => {
          if (res && res.code === '0') {
            resolve(res.data);
          }
          reject();
        }, () => {
          reject();
        });
      });
    },
    getAttachmentInfo () {
      return new Promise((resolve, reject) => {
        PurchaseBusinessService.getPurchaseProjectDetail({
          purchaseId: this.id,
          echoCode: 'FILE'
        }).then(res => {
          if (res && res.code === '0' && res.data && res.data.files) {
            resolve(res.data.files);
          }
          reject();
        }, () => {
          reject();
        });
      });
    },
    getProjectContractUrl (contractType) {
      Service.getProjectContractUrl({
        projectId: this.id,
        projectType: 2,
        contractType: contractType
      }).then(res => {
        if (res && res.code === '0') {
          if ([6, 7].includes(contractType)) {
            this.fileObj.docUrl1 = res && res.data && res.data.docUrl;
          } else {
            this.fileObj.docUrl = res && res.data && res.data.docUrl;
          }
        }
      });
    },
    openWindow (url) {
      url && window.open(url);
      // if(typeof key === 'string') {
      //   window.open(this.fileObj[key]);
      // } else {
      //   window.open(key.url);
      // }
    },
    getDetail () {
      this.getProjectDetail();
    }
  }
};
